import React, { useState } from 'react';
import TextInput from '../general/inputs/TextInput';
import { ButtonDark, ButtonOutline } from '../general/Styles.jsx';
import { styled } from "styled-components";
import LocationArrow from '../Icons/LocationArrow';
import useBrand from '../../hooks/useBrand';

const TabContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
`;

const StyledDealerForm = styled.div`
  width: 100%;
  max-width: 840px;
  display: flex;
  flex-direction: column;
  margin: 24px auto;
  align-items: center;
  justify-content: center;
`;

const HTag = styled.div`
  color: #000;
  text-align: center;
  font-size: 32px;
  font-style: normal;
  line-height: 36px;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 28px;
  }

  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const SubContainerOne = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 24px auto;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    gap: 16px;
    margin: 32px auto;
  }
`;

const SubContainer = styled.div`
  width: 100%;
  display: flex;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`;

const StyledTextInput = styled(TextInput)<{ brand: string; }>`
  width: 90%;
  max-width: 400px;
  height: 60px;
  flex-shrink: 0;
  margin-bottom: 16px;
  position: relative !important;

  label {
    opacity: 0;
  }

  @media (min-width: 768px) {
    margin-bottom: 0;
  }
`;

const StyledButtonDark = styled(ButtonDark)<{ theme: string; $inactive: boolean; }>`
  height: 60px;
  padding: 14px 32px;
  flex-shrink: 0;
  margin-top: 24px;

  @media (min-width: 768px) {
    margin-top: 0;
  }

  &.inactive {
    background-color: #EAEAEA; 
    color: #888888; 
    font-size: 16px; 
    font-weight: 500;
  }
`;

const StyledButtonOutline = styled(ButtonOutline)<{ theme: string; }>`
  ${({ theme }) => theme == 'Jackson' && `
    border: 0;
  `}
`

const StyledSubContainer = styled(SubContainer)`
  color: #1A1B1B;
  text-align: center;
  flex-shrink: 0;

    &:hover {
      svg {
        fill: #fff;
      }
    }

  small {
    font-family: "HelveticaNowDisplay";
    font-size: 16px;
    font-style: normal;
    line-height: 20px;
  }
`;

type DealerFormProps = {
  search: (input: any) => void;
  error: boolean;
  site: any;
};

const DealerForm = ({ search, error, site }: DealerFormProps) => {
  const [input, setInput] = useState('');
  const brand = useBrand();

  return (
    <TabContainer>
      <StyledDealerForm className="dealer-finder-form FenderAuthorizedDealer">
        <HTag>Locate a {site} Authorized Dealer</HTag>

        <SubContainerOne className="FenderAuthorizedDealer-container">
          <StyledTextInput
            value={input}
            label="Enter Your Zip Code or City"
            onChange={(e: any) => setInput(e.target.value)}
            onKeyPress={(e: any) => e.key === 'Enter' ? search(input) : null}
            onKeyDown={(e: any) => {}}
            id="dealerFormInput"
            name="dealerFormInput"
            brand={brand}
          />
          <StyledButtonDark
            theme={site}
            id="dealerLocatorSubmit"
            onClick={() => search(input)}
            $inactive={input.length < 2 ? false : true}
          >
            Search
          </StyledButtonDark>
        </SubContainerOne>

        <StyledSubContainer id="use-location__container" className="use-location">
          <StyledButtonOutline id="dealerLocatorLocate" theme={site} onClick={() => search('my location')}>
            <LocationArrow />
            <small>Use My Location</small>
          </StyledButtonOutline>
        </StyledSubContainer>
      </StyledDealerForm>

      {error && (
        <SubContainer id="React-FenderAuthorizedDealer-error">
          <p>We didn't find any dealers in your area.</p>
          {site == 'Fender' ? (
            <p> Try Searching a different location below or contact fender customer service at <a id="React-FenderAuthorizedDealer-error-link" href="tel:+18008569801">800-856-9801</a>.</p>
          ) : (
            <p> Please try again.</p>
          )}
        </SubContainer>
      )}
    </TabContainer>
  );
};

export default DealerForm;
